import EventDetail from "@/src/screens/events/event-details";
import { useGetEventByIdQuery } from "@/src/services/api/events/events.hooks";
import { router, useLocalSearchParams } from "expo-router";
import { useTranslation } from "react-i18next";
import { ActivityIndicator, Text, View } from "react-native";

export default function EventDetailScreen() {
  const { t } = useTranslation();
  const { id } = useLocalSearchParams<{ id: string }>();

  const { data: event, isLoading, isError } = useGetEventByIdQuery(id);

  if (isLoading) {
    return (
      <View className="flex-1 items-center justify-center">
        <ActivityIndicator />
      </View>
    );
  }

  if (isError || !event) {
    return (
      <View className="flex-1 items-center justify-center">
        <Text className="text-onyx">{t("ERROR_EVENT_NOT_FOUND")}</Text>
      </View>
    );
  }

  return <EventDetail event={event} onBack={() => router.back()} />;
}
